/* Parbiart — a „Kígyó" perem (a Mix látványtervből, az ügyfél kérésére megtartva, 2026-10-07).
   A színsáv alján végigfutó kígyótest a sáv VALÓDI szélességére rajzolva, egy darabban, a fej a
   test végén — ezért szkript rajzolja, nem ismétlődő minta. A sáv színét veszi fel (currentColor).
   JS nélkül a CSS hullámos pereme látszik (.pb-drips--kigyo::after). Forrás: latvanyterv/mix/parts/script.html */
(function () {
  function f1(n) { return Math.round(n * 10) / 10; }
  function rajzol(W) {
    var s = Math.max(0.45, Math.min(1, W / 1200));
    var A = 13 * s, y0 = 20 * s, L = 190 * s, sw = 18 * s, xe = W - 96 * s, pts = [], x;
    for (x = -30; x <= xe; x += 6) pts.push([x, y0 + A * Math.sin(2 * Math.PI * x / L)]);
    pts.push([xe, y0 + A * Math.sin(2 * Math.PI * xe / L)]);
    var d = 'M' + pts.map(function (p) { return f1(p[0]) + ',' + f1(p[1]); }).join(' L');
    var ang = Math.atan2(A * Math.cos(2 * Math.PI * xe / L) * 2 * Math.PI / L, 1) * 180 / Math.PI;
    var e = pts[pts.length - 1];
    var h = '<rect x="0" y="0" width="' + W + '" height="' + f1(6 * s) + '"/>';
    h += '<path d="' + d + '" fill="none" stroke="currentColor" stroke-width="' + f1(sw) + '" stroke-linecap="round" stroke-linejoin="round"/>';
    /* a hát mintája: halvány rombuszok a test középvonalán */
    for (var k = 4; k < pts.length - 6; k += 5) {
      var p = pts[k];
      h += '<rect class="sc" x="' + f1(p[0] - 3 * s) + '" y="' + f1(p[1] - 3 * s) + '" width="' + f1(6 * s) + '" height="' + f1(6 * s) +
        '" transform="rotate(45 ' + f1(p[0]) + ' ' + f1(p[1]) + ')"/>';
    }
    /* a fej a test végén, a test irányába fordítva */
    h += '<g transform="translate(' + f1(e[0]) + ',' + f1(e[1]) + ') rotate(' + f1(ang) + ') scale(' + s + ')">' +
      '<path d="M-6,-9 C10,-17 34,-16 46,-6 C52,-1 52,5 46,9 C34,18 10,18 -6,9 Z"/>' +
      '<circle class="dk" cx="30" cy="-5" r="3.4"/><circle class="dk" cx="46" cy="-2" r="1.4"/>' +
      '<path class="tg" d="M50,2 L66,3 M66,3 L73,-3 M66,3 L73,9"/></g>';
    return { h: h, H: 60 * s };
  }
  function mind() {
    document.querySelectorAll('[data-pb-kigyo]').forEach(function (svg) {
      var sav = svg.parentElement, W = sav.clientWidth;
      if (!W) return;
      var o = rajzol(W);
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + f1(o.H));
      svg.setAttribute('height', f1(o.H));
      svg.innerHTML = o.h;
      sav.style.setProperty('--pb-drip-h', f1(o.H) + 'px');
      sav.classList.add('pb-kigyo-kesz');
    });
  }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(mind, 120); });
  document.addEventListener('shopify:section:load', mind);
  mind();
})();
